export class ChartGrid {
    columns: number;
    rows: number;
    constructor(gridData: any) {
        gridData = (gridData || {});
        this.columns = gridData.columns;
        this.rows = gridData.rows;
    }
}
